import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c6720c5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "dialog"
};
const _hoisted_2 = {
  class: "dialog__body"
};
const _hoisted_3 = {
  key: 0,
  class: "file-pop-list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FilePopItem = _resolveComponent("FilePopItem");
  const _component_Spin = _resolveComponent("Spin");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_Transition, {
    name: "mask"
  }, {
    default: _withCtx(() => [_ctx.showFilePop ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "cover",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.close && _ctx.close(...args))
    })) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_Transition, {
    name: "pop"
  }, {
    default: _withCtx(() => [_ctx.showFilePop ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.parentIds.length > 1 ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      href: "javascript:;",
      class: "arrow",
      title: "返回",
      onClick: _cache[1] || (_cache[1] =
      //@ts-ignore
      (...args) => _ctx.goBack && _ctx.goBack(...args))
    })) : _createCommentVNode("", true), _ctx.parentIds.length > 2 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "back-index",
      onClick: _cache[2] || (_cache[2] =
      //@ts-ignore
      (...args) => _ctx.backHome && _ctx.backHome(...args))
    }, " 返回首页 ")) : _createCommentVNode("", true), _ctx.parentIds.length <= 2 ? (_openBlock(), _createElementBlock("a", {
      key: 2,
      href: "javascript:;",
      class: "qh-icon-close",
      title: "关闭",
      onClick: _cache[3] || (_cache[3] =
      //@ts-ignore
      (...args) => _ctx.close && _ctx.close(...args))
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("h2", {
      class: _normalizeClass({
        'more': _ctx.parentIds.length > 1,
        'deep': _ctx.parentIds.length > 2
      })
    }, _toDisplayString(_ctx.parentIds[_ctx.parentIds.length - 1].name), 3), !_ctx.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, id => {
      return _openBlock(), _createBlock(_component_FilePopItem, {
        id: id,
        key: id,
        load: _ctx.loadFunction
      }, null, 8, ["id", "load"]);
    }), 128))])) : _createCommentVNode("", true), _ctx.isLoading ? (_openBlock(), _createBlock(_component_Spin, {
      key: 1,
      top: 300
    })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
    _: 1
  })], 64);
}